import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {FlujoVentaPasoTiposPersonas} from '../_models/flujo-venta-paso-tipos-personas';
import {SegurosTiposPersonas} from '../_models/seguros-tipos-personas';

@Injectable({
  providedIn: 'root'
})
export class SegurosTiposPersonasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/segurosTiposPersonas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegurosTiposPersonas[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegurosTiposPersonas[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegurosTiposPersonas ) );
  }

  listadoPorIdSeguro( id: string ) {
    return this.httClient.get( this.rutServicio + '/idSeguro/' + id ).pipe( map( res => res as SegurosTiposPersonas[] ) );
  }

  crear( regCrear: SegurosTiposPersonas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegurosTiposPersonas ) );
  }

  actualizar( regActualizar: SegurosTiposPersonas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegurosTiposPersonas ) );
  }

  bulk( registros: SegurosTiposPersonas[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as SegurosTiposPersonas[] ) );
  }

}
